import type {Json} from '../../../HeliportJS/dist/models/json';

export const parseJwt = (token: string): Json => {
  const base64Url = token.split('.')[1];
  if (!base64Url) {
    throw new Error('Invalid JWT');
  }
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};
